var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.23828 12.167L1.70403 14.0307C1.78515 14.3553 1.9724 14.6433 2.23603 14.8492C2.49966 15.0551 2.82454 15.1669 3.15903 15.167H14.3175C14.652 15.1669 14.9769 15.0551 15.2405 14.8492C15.5042 14.6433 15.6914 14.3553 15.7725 14.0307L16.2383 12.167M8.73828 10.667V1.66699V10.667ZM8.73828 10.667L5.73828 7.66699L8.73828 10.667ZM8.73828 10.667L11.7383 7.66699L8.73828 10.667Z",
    stroke: "#133F7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadVector);
export default __webpack_public_path__ + "static/media/download-vector.89b812151124f4081d031cc67f6b3375.svg";
export { ForwardRef as ReactComponent };